import { render, staticRenderFns } from "./BaseDateTimePicker.vue?vue&type=template&id=20fbca4e&scoped=true&"
import script from "./BaseDateTimePicker.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseDateTimePicker.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseDateTimePicker.vue?vue&type=style&index=0&id=20fbca4e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fbca4e",
  null
  
)

export default component.exports